export default __webpack_public_path__ + "static/media/icon-notification.e43f3236.svg";